import { useSearchParams } from 'react-router-dom';
import { TalentSearchState } from '../types/talents';

export const useSearchTalentsParams = (initValue: TalentSearchState) => {
  const [getSearchParams] = useSearchParams();
  const stateStr = getSearchParams.get('state');
  let stateAny: TalentSearchState;
  if (stateStr) {
    stateAny = JSON.parse(stateStr) as TalentSearchState;
  } else {
    stateAny = initValue;
  }

  const setSearchTalentsParams = (state: TalentSearchState) => {
    const stateStr = JSON.stringify(state);
    window.history.pushState(
      stateStr,
      '',
      `${window.location.protocol}//${window.location.host}${window.location.pathname}?state=${encodeURIComponent(
        stateStr,
      )}`,
    );
  };

  return { searchTalentParams: stateAny, setSearchTalentsParams };
};
